export const DMARC_EFFECTIVENESS_REQUEST = 'DMARC_EFFECTIVENESS_REQUEST';
export const DMARC_EFFECTIVENESS_SUCCESS = 'DMARC_EFFECTIVENESS_SUCCESS';
export const DMARC_EFFECTIVENESS_FAILURE = 'DMARC_EFFECTIVENESS_FAILURE';
